import React, { Component } from 'react'
import { connect } from 'react-redux'
import { GET_LIST } from 'react-admin'
import { change } from 'redux-form';
import _ from 'lodash'

import DocumentoUploadDialog from './DocumentoUploadDialog'
import { SearchSelect } from '../Inputs'
import dataProvider from '../../utils/dataProvider'


class DocumentSelect extends Component {

    constructor(props) {
        super(props);

        this.state = {
          choices: [],
          placeholder: 'Seleccione o Escriba una busqueda'
        }
    }

    componentDidMount() {
      this.handleGetList()
      if (this.props.input && this.props.input.value) {
        this.handleGetList(this.props.input.value)
      }
    }

    handleGetList(value) {
      const params = {
        pagination: {
            page: 1,
            perPage: 25
        },
        sort: {
            field: '-created_at',
            order: 'ASC'
        },
        filter: {
            type: this.props.documentType
        }
      }
      if (value) {
        params.filter.id = value
      }
      dataProvider(GET_LIST, 'documentos', params)
        .then(response => {
          this.setState({ choices: [...this.state.choices, ...response.data] })
        })
        .catch((e) => {
          console.error(e)
        })
    }

    renderChildren() {
      let options = _.map(this.state.choices || [], (data) => ({
          value: data.id,
          label: data.name
      }))
      options.unshift({ value: 1, label: "Sin documento/No aplica" })
      return options
    }

    changeSelectValue(value, text) {
        const choices = this.state.choices
        this.setState({
            choices: choices.concat([{id: value, name: text}])
        })
        this.props.change('redux-form', this.props.input.name, value)
    }

    render() {
        const { documentType, extensions, decreto, change, ...rest } = this.props
        const { placeholder } = this.state
        const options = this.renderChildren() || []
        
        return (
            <React.Fragment>
                <SearchSelect
                  {...rest}
                  resource="documentos"
                  options={options}
                  placeholder={placeholder}
                  searchType="async"
                  isMulti={false}
                />
                {!this.props.disabled && (
                    <DocumentoUploadDialog
                        changeSelectValue={this.changeSelectValue.bind(this)}
                        documentType={documentType}
                        decreto={decreto}
                        acceptedExt={extensions}
                    />
                )}
            </React.Fragment>
        )
    }
}

export const DocumentSelectInput = connect(null, { change })(DocumentSelect)
